export default "__VITE_ASSET__BgfeRfaZ__"